module.exports = __webpack_public_path__ + "img/Verification.bfadfa3a.svg";